module.exports = __webpack_public_path__ + "img/Success.a8adfb22.png";